/**
 * Error no previsto (006 · T019, research R-24; contracts/staff-ui.md §6).
 *
 * `GenericErrorScreen` (`generic-error`): "Algo salió mal" + "Inténtalo nuevamente en unos
 * segundos." + "Reintentar". La usa el `errorComponent` de `__root.tsx` (T056) y las pantallas de
 * datos ante un 5xx o una respuesta que no valida contra el esquema. **Nunca** muestra el código
 * de error, el `request_id` ni una traza: por eso no recibe el error, solo `onRetry`. La
 * observabilidad es la de la API (pino registra cada 5xx con su `request_id`).
 *
 * Con `nav` (la `TabBar`) la pantalla conserva sus pestañas: el trabajador puede irse a otra.
 */
import { CircleAlert } from 'lucide-react';

import { t } from '../../i18n';

import { Button } from './button';
import { Screen } from './screen';

import type { ReactNode } from 'react';

export interface GenericErrorScreenProps {
  onRetry: () => void;
  /** Barra de pestañas, si la pantalla que falló la tenía. */
  nav?: ReactNode;
}

export function GenericErrorScreen({ onRetry, nav }: GenericErrorScreenProps) {
  return (
    <Screen
      data-testid="generic-error"
      align="center"
      nav={nav}
      footer={<Button onClick={onRetry}>{t('shell.error.retry')}</Button>}
    >
      <div className="flex flex-col items-center gap-fm-3 text-center">
        <span
          aria-hidden="true"
          className="flex h-16 w-16 items-center justify-center rounded-fm-pill bg-fm-primary-soft text-fm-primary-text"
        >
          <CircleAlert size={28} />
        </span>
        <h1 className="font-display text-fm-2xl font-extrabold text-fm-text">
          {t('shell.error.title')}
        </h1>
        <p className="text-fm-base text-fm-text-secondary">{t('shell.error.description')}</p>
      </div>
    </Screen>
  );
}
